module.exports = __webpack_public_path__ + "img/sucess05.0cda1c45.png";